<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import { contactId } from "@core/schema/ids/contactId.js";
	import heroPhotoMobile from "../assets/final_photos/DSC_0358.jpg?webp&h=540&imagetools";
	import heroPhoto from "../assets/final_photos/DSC_0358.jpg?webp&h=1080&imagetools";
	import ContactForm from "../components/ContactForm.svelte";
	import PageHero from "../components/PageHero.svelte";
	import WhyCooperateCarousel from "../components/WhyCooperateCarousel.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./Inquiry.translations.json" with { type: "json" };
	import type { InquiryProps } from "./InquiryProps.js";

	const _: InquiryProps = $props();
	const translate = getTranslate(translations);

	// Čtení URL parametru service z query stringu
	let serviceFromUrl: string | undefined = $state();

	if (typeof window !== "undefined") {
		const urlParams = new URLSearchParams(window.location.search);
		serviceFromUrl = urlParams.get("service") ?? undefined;
	}
</script>

<Layout>
	<PageHero
		image={heroPhoto}
		mobileImage={heroPhotoMobile}
		alt={translate("heroAlt")}
		heading={translate("heroHeading")}
		text={translate("heroText")}
		text2={translate("heroText2")}
		buttonText={translate("heroButtonText")}
		vertical
		customIdHref={contactId}
		brightness={160}
	/>
	<WhyCooperateCarousel />
	<ContactForm heading="inquiry" service={serviceFromUrl} />
</Layout>
